import { i18n } from '@/setup/i18n';

export const changeTitlePageWithRoute = ({ i18nTitleKey }) => {
  const titleByKey = i18nTitleKey ? `| ${i18n().t(`title.${i18nTitleKey}`)}` : '';
  document.title = `${process.env.APP_NAME} ${titleByKey}`;
};
